import React, { useState } from "react";
import Tabs from "../../../../../components/common/Tabs/Tabs";
import CustomDropdown from "../../../../../components/common/Dropdown/CustomDropDown";
import All from "./All/All";
import Pending from "./Pending/Pending";
import Processing from "./Processing/Processing";
import Shipped from "./Shipped/Shipped";
import Intransit from "./Intransit/Intransit";
import Delivered from "./Delivered/Delivered";

const TrackingAndUpdates = () => {
  const tabs = [
    "All",
    "Pending",
    "Processing",
    "Shipped",
    "In transit",
    "Delivered",
  ];
  const [activeTab, setActiveTab] = useState(tabs[0]);

  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab}>
        <div className="d-flex gap-2">
          <div className="bg-white border border-secondary rounded px-2">
            <CustomDropdown title={"Print"} />
          </div>
          <div className="bg-white border border-secondary rounded px-2">
            <CustomDropdown title={"Export"} />
          </div>
          <div className="bg-white border border-secondary rounded px-2">
            <CustomDropdown title={"View History"} />
          </div>
        </div>
      </Tabs>

      {activeTab === "All" && <All />}
      {activeTab === "Pending" && <Pending />}
      {activeTab === "Processing" && <Processing />}
      {activeTab === "Shipped" && <Shipped />}
      {activeTab === "In transit" && <Intransit />}
      {activeTab === "Delivered" && <Delivered />}
    </div>
  );
};

export default TrackingAndUpdates;